import React, { useEffect, useState } from 'react';
import '../../Styles/Styles.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { toast } from 'react-toastify';
import CssClass from "../../Styles/common.module.css";
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import { GetPageAuthorityFn } from "../../Common/authority";
import CreateEmployee from "../../Components/Users/Employee/InsertEmployee";
import EmployeeUpdate from '../../Components/Users/Employee/EmployeeUpdate';
import EmployeeDelete from '../../Components/Users/Employee/EmployeeDelete';
import EmployeeActivator from '../../Components/Users/Employee/EmployeeActivator';
import { differenceInYears, differenceInMonths, differenceInDays, format } from 'date-fns';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquarePlus, faPenToSquare, faTrashCan, faDownload } from "@fortawesome/free-solid-svg-icons";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { FilterMatchMode } from 'primereact/api';

const PAGE_NAME = "Employee.js_";
const MODULE_ID = "WEB_URS_002";

const Employee = (props) => {
  const navigate = useNavigate();
  const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
  const [showCreateEmployee, setShowCreateEmployee] = useState(false);
  const [showActivator, setShowActivator] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedUser, setSelectedUser] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [reload, setReload] = useState(false);
	const [allData, setAllData] = useState([]);
  const [editData, setEditData] = useState([]);
	const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    USERNAME: { value: null, matchMode: FilterMatchMode.CONTAINS },
    EMAIL: { value: null, matchMode: FilterMatchMode.CONTAINS },
    DEPT_NAME: { value: null, matchMode: FilterMatchMode.CONTAINS },
    ROLE_NAME: { value: null, matchMode: FilterMatchMode.CONTAINS },
    EMPLOYMENT_STATUS: { value: null, matchMode: FilterMatchMode.CONTAINS },
    SERVICE_LENGTH: { value: null, matchMode: FilterMatchMode.CONTAINS },
    UPDATE_BY: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
    READALL: "N",
  });

  useEffect(() => {
    let promise = GetPageAuthorityFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Dashboard");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
          READALL: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
        toast.error(error);
        navigate("/Dashboard");
      }
    );
  }, [userId, navigate]);

	//region get employee list
  useEffect(() => {
		if (actionAuthority.READ === "Y") {
    	let functionName = "useEffect Get Employee List";
    try {
      setLoading(true);
      setLoadingText("Getting Employee List, please wait...");
			setAllData([]);
			const listItems = [];

      http
        .get("api/profile/GetAllProfiles?_sysUser=" + userId + "&_year=" + selectedYear, 
					{ timeout: 10000 })
        .then((response) => {
          if (response.data.length > 0) {
						response.data.forEach((data) => {
              const startDateStr = data.SERVICE_STARTDATE;
              const endDateStr = data.SERVICE_ENDDATE;
              let timeText = '';
              let durationText = '';

              if (startDateStr) {
                const startDate = new Date(startDateStr);
                let endDate = new Date();

                if (endDateStr && new Date(endDateStr) > startDate) {
                  endDate = new Date(endDateStr);
                }

                const totalYears = differenceInYears(endDate, startDate);
                const tempDateAfterYears = new Date(startDate);
                tempDateAfterYears.setFullYear(tempDateAfterYears.getFullYear() + totalYears);

                const totalMonths = differenceInMonths(endDate, tempDateAfterYears);
                const tempDateAfterMonths = new Date(tempDateAfterYears);
                tempDateAfterMonths.setMonth(tempDateAfterMonths.getMonth() + totalMonths);

                const totalDays = differenceInDays(endDate, tempDateAfterMonths);

                const formattedStart = format(startDate, "dd MMM yyyy");
                const formattedEnd = endDateStr && new Date(endDateStr) > startDate
                  ? format(endDate, "dd MMM yyyy")
                  : "Present";

                const yearLabel = `${totalYears} year${totalYears !== 1 ? 's' : ''}`;
                const monthLabel = `${totalMonths} month${totalMonths !== 1 ? 's' : ''}`;
                const dayLabel = `${totalDays} day${totalDays !== 1 ? 's' : ''}`;

                timeText = `${yearLabel}, ${monthLabel}, ${dayLabel}`;
                durationText = `${formattedStart} - ${formattedEnd} (${timeText})`;
              }

              const date = new Date(data.UPDATE_DATETIME);
              const formattedDate =
                date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-GB', {
                  hour12: true,
                  hour: '2-digit',
                  minute: '2-digit',
                }).toUpperCase();

              const accessDate = new Date(data.LAST_ACCESS_DATETIME);
              const formattedAccessDate =
                accessDate.toLocaleDateString('en-GB') + ' ' + accessDate.toLocaleTimeString('en-GB', {
                  hour12: true,
                  hour: '2-digit',
                  minute: '2-digit',
                }).toUpperCase();

							listItems.push({
								key: data.USER_MST_GUID,
								USER_ID: data.USER_MST_GUID,
								USERNAME: data.USERNAME,
                EMAIL: data.EMAIL,
                DEPT_ID: data.DEPT_ID,
                DEPT_NAME: data.DEPT_NAME,
								ROLE_ID: data.ROLE_ID,
								ROLE_NAME: data.ROLE_NAME,
                WORK_TYPE: data.CATEGORY_TYPE_MST_ID,
                EMPLOYMENT_STATUS: data.EMPLOYMENT_STATUS,
                SERVICE_LENGTH: durationText || '',
                SERVICE_PERIOD: timeText || '',
                SERVICE_STARTDATE: data.SERVICE_STARTDATE,
                SERVICE_ENDDATE: data.SERVICE_ENDDATE,
								STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                LAST_ACCESS_DATETIME: formattedAccessDate,
                UPDATE_DATETIME: formattedDate,
                UPDATED_BY: data.UPDATED_BY,
								ANNUAL_LEAVE_ENTITLED: data.ANNUAL_LEAVE_ENTITLED,
								ANNUAL_LEAVE_BRINGFORWARD: data.ANNUAL_LEAVE_BRINGFORWARD,
								ANNUAL_LEAVE_TAKEN: data.ANNUAL_LEAVE_TAKEN,
								ANNUAL_LEAVE_BALANCE: Math.max(0, data.ANNUAL_LEAVE_BALANCE ?? 0),
								ANNUAL_LEAVE_MTD_BALANCE: Math.max(0, data.ANNUAL_LEAVE_MTD_BALANCE ?? 0),
                MEDICAL_LEAVE_ENTITLED: data.MEDICAL_LEAVE_ENTITLED,
                MEDICAL_LEAVE_TAKEN: data.MEDICAL_LEAVE_TAKEN,
								MEDICAL_LEAVE_BALANCE: Math.max(0, data.MEDICAL_LEAVE_BALANCE ?? 0),
                MEDICAL_LEAVE_CLAIM: (data.MEDICAL_CLAIMED ?? 0) + ' / ' + data.MEDICAL_LEAVE_ENTITLED_CLAIM,
                HOSPITALIZATION_LEAVE: data.HOSPITALIZATION_TAKEN + ' / ' + data.HOSPITALIZATION_CLAIM,
                UNPAID_LEAVE_TAKEN: data.UNPAID_LEAVE_TAKEN,
							});
						});
					}
					setAllData(listItems);
        })
        .catch((err) => {
          toast.error("Error on getting employee list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
    } catch (err) {
      toast.error("Error on getting employee list. Please try again.");
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
	}
  }, [reload, actionAuthority, userId, selectedYear]);

	//#region event handler
	const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const createEmployeeModal = () => {
    setShowCreateEmployee(!showCreateEmployee);
  };

  const showUpdateModal = (e, row) => {
    setShowUpdate(!showUpdate);
    setEditData(row);
  };

  const hideUpdateModal = () => {
    setShowUpdate(!showUpdate);
    setEditData(null);
  };

  const showDeleteModal = (row) => {
    setShowDelete(true);
    setEditData(row);
  };

  const hideDeleteModal = () => {
    setShowDelete(false);
    setEditData(null);
  };
  
	const showActivatorModal = (e, row) => {
    setShowActivator(!showActivator);
    setEditData(row);
  };

  const hideActivatorModal = () => {
    setShowActivator(!showActivator);
    setEditData(null);
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    if (!_filters['global']) {
      _filters['global'] = { value: null, matchMode: FilterMatchMode.CONTAINS };
    }

    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <span className="text-lg font-semibold" style={{ fontSize: '22px' }}>Employee</span>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Search"
            className="table-search-input"
            style={{ height: '40px', fontSize: '0.9rem' }}
          />
        </IconField>
      </div>
    );
  };

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Action" rowSpan={2} />
        <Column header="#" rowSpan={2} />
        <Column header="Name" field="USERNAME" sortable frozen filter filterPlaceholder="Search by name" rowSpan={2} />
        <Column header="Email" field="EMAIL" sortable rowSpan={2} />
        <Column header="Dept" field="DEPT_NAME" sortable rowSpan={2} />
        <Column header="Role" filter filterPlaceholder="Search by name" field="ROLE_NAME" sortable rowSpan={2} />
        <Column header="Work Type" field="EMPLOYMENT_STATUS" sortable rowSpan={2} />
        <Column header="Service Length" field="SERVICE_LENGTH" sortable rowSpan={2} />
        <Column header="Status" field="STATUS" sortable rowSpan={2}/>
        <Column header="Annual Leave" colSpan={5} headerStyle={{ backgroundColor: '#41c353' }}/>
        <Column header="Medical Leave" colSpan={4} headerStyle={{ backgroundColor: '#46b1e1' }} />
        <Column header="Unpaid Leave" colSpan={1} headerStyle={{ minWidth: '110px', backgroundColor: '#ff7c80' }} />
        <Column header="Claim" colSpan={1} headerStyle={{ minWidth: '110px', backgroundColor: '#ff9900' }} />
        <Column header="Last Access" field="LAST_ACCESS_DATETIME" sortable rowSpan={2} />
        <Column header="Last Update" field="UPDATE_DATETIME" sortable rowSpan={2} />
        <Column header="Update By" field="UPDATE_BY" sortable rowSpan={2} />
      </Row>
      <Row>
        <Column header="Entitled" field="ANNUAL_LEAVE_ENTITLED" sortable headerStyle={{ backgroundColor: '#84e291' }} />
        <Column header="Bring Forward" field="ANNUAL_LEAVE_BRINGFORWARD" sortable headerStyle={{ backgroundColor: '#84e291' }} />
        <Column header="Taken" field="ANNUAL_LEAVE_TAKEN" sortable headerStyle={{ backgroundColor: '#84e291' }} />
        <Column header="YTD Balance" field="ANNUAL_LEAVE_BALANCE" sortable headerStyle={{ backgroundColor: '#84e291' }} />
        <Column header="MTD Balance" field="ANNUAL_LEAVE_MTD_BALANCE" sortable headerStyle={{ backgroundColor: '#84e291' }} />
        <Column header="Entitled" field="MEDICAL_LEAVE_ENTITLED" sortable headerStyle={{ backgroundColor: '#83cbeb' }} />
        <Column header="Taken" field="MEDICAL_LEAVE_TAKEN" sortable headerStyle={{ backgroundColor: '#83cbeb' }} />
        <Column header="Balance" field="MEDICAL_LEAVE_BALANCE" sortable headerStyle={{ backgroundColor: '#83cbeb' }} />
        <Column header="Hospitalization" field="HOSPITALIZATION_LEAVE" sortable headerStyle={{ backgroundColor: '#83cbeb' }} />
        <Column header="Taken" field="UNPAID_LEAVE_TAKEN" sortable headerStyle={{ display: 'flex', justifyContent: 'center', padding: '1.44rem', backgroundColor: '#ffa7a7' }} />
        <Column header="Medical (RM)" field="MEDICAL_LEAVE_CLAIM" sortable headerStyle={{ backgroundColor: '#ffbd5d' }} />
      </Row>
    </ColumnGroup>
  );

  const HighlightCell = ({ text, keyword }) => {
    if (!keyword || !text) return text;

    const regex = new RegExp(`(${keyword})`, "gi");
    const parts = text.split(regex);

    return (
      <>
        {parts.map((part, i) =>
          part.toLowerCase() === keyword.toLowerCase() ? (
            <span key={i} className="highlight-keyword">{part}</span>
          ) : (
            part
          )
        )}
      </>
    );
  };

  const TruncatedHighlightCell = ({ text, keyword }) => {
    const [expanded, setExpanded] = useState(false);
    const maxLength = 51;

    const highlightText = (text, keyword) => {
      if (!keyword) return text;

      const regex = new RegExp(`(${keyword})`, 'gi');
      return text.split(regex).map((part, i) =>
        regex.test(part) ? <mark key={i}>{part}</mark> : part
      );
    };

    const isLong = text.length > maxLength;
    const displayText = expanded || !isLong ? text : text.slice(0, maxLength) + '...';

    return (
      <div>
        <span>{highlightText(displayText, keyword)}</span>
        {isLong && (
          <span
            onClick={() => setExpanded((prev) => !prev)}
            style={{ color: '#007bff', cursor: 'pointer', marginLeft: '5px' }}
          >
            {expanded ? 'Show less' : 'Read more'}
          </span>
        )}
      </div>
    );
  };
  
  const onExcelHandler = () => {
    window.open(
      common.c_getApiUrl() +
        "api/profile/ExportExcel?_sysUser=" +
        userId
    );
  };
	//#endregion

  return (
    <>
      <div className={CssClass.btnWrapperTwo}>
        {actionAuthority.WRITE === "Y" && (
        <>
          <Comp.Button
            id="btnAdd"
            type="general"
            style={{ width: '140px' }}
            onClick={createEmployeeModal}
            className={CssClass.registerButton}
          >
            <FontAwesomeIcon icon={faSquarePlus} />
            <span>&nbsp; ADD</span>
          </Comp.Button>
          <Comp.Button
            id="btnExport"
            type="general"
            style={{ width: '140px', backgroundColor: "green" }}
            // onClick={onExcelHandler}
          >
            <FontAwesomeIcon icon={faDownload} />
            <span>&nbsp; EXPORT</span>
          </Comp.Button>
        </>
        )}
      </div>
      <div style={{ marginLeft: "18px" }}>
				<button
					onClick={() => setSelectedYear(prev => prev - 1)}
					disabled={selectedYear <= 2025}
					style={{
						background: '#fff',
						color: '#373a3c',
						border: '1px solid #ccc',
						borderRadius: '4px',
						fontSize: '18px',
						cursor: 'pointer',
						padding: '4px 10px',
						transition: 'background 0.3s'
					}}
				>
					&lt;
				</button>

				<span style={{ fontSize: '18px', fontWeight: 'bold', margin: '0 15px' }}>
					{selectedYear}
				</span>

				<button
					onClick={() => setSelectedYear(prev => prev + 1)}
					disabled={selectedYear >= currentYear}
					style={{
						background: '#fff',
						color: '#373a3c',
						border: '1px solid #ccc',
						borderRadius: '4px',
						fontSize: '18px',
						cursor: 'pointer',
						padding: '4px 10px',
						transition: 'background 0.3s'
					}}
				>
					&gt;
				</button>
			</div>
      <div className={`${CssClass.cardTwo} ${CssClass.employeeTableCardTwo}`}>
        <div style={{ maxWidth: "100%" }}>
          <DataTable value={allData} dataKey="USER_ID" header={renderHeader()} headerColumnGroup={headerGroup} filters={filters} filterDisplay="menu" 
            onFilter={(e) => { 
              const newFilters = e.filters; 
              setFilters(newFilters); 
              const globalKeyword = newFilters.global?.value || '';
              const updated = allData.map(item => ({ ...item, __FILTER_KEYWORD__: { USERNAME: newFilters.USERNAME?.value || globalKeyword, 
                EMAIL: newFilters.EMAIL?.value || globalKeyword, EMPLOYMENT_STATUS: newFilters.EMPLOYMENT_STATUS?.value || globalKeyword, 
                DEPT_NAME: newFilters.DEPT_NAME?.value || globalKeyword, SERVICE_LENGTH: newFilters.SERVICE_LENGTH?.value || globalKeyword, 
                ROLE_NAME: newFilters.ROLE_NAME?.value || globalKeyword, UPDATE_BY: newFilters.UPDATE_BY?.value || globalKeyword }})); 
              setAllData(updated); 
            }}
            selectionMode="multiple" selection={selectedUser} onSelectionChange={(e) => setSelectedUser(e.value)} loading={loading} 
            globalFilter={globalFilterValue} globalFilterFields={['USERNAME', 'EMAIL', 'DEPT_NAME', 'ROLE_NAME', 'EMPLOYMENT_STATUS', 'SERVICE_LENGTH']} 
            removableSort emptyMessage="No employee found." paginator rows={rowsPerPage} first={currentPage * rowsPerPage}
            onPage={(e) => { setCurrentPage(e.page); setRowsPerPage(e.rows); }} rowsPerPageOptions={[10, 20, 30, 40, 50]} 
            scrollable scrollHeight="700px" showGridlines className="datatable" tableStyle={{ minWidth: '50rem' }}
          >
            <Column
              body={(rowData) => (
                <div style={{ textAlign: "-webkit-center" }} className={CssClass.tdBtnActionWrapperTwo}>
                  {(actionAuthority.WRITE === "Y")&& (
                    <span title="Modify">
                      <Comp.Button
                          id="btnEdit"
                          type="general"
                          onClick={(e) => showUpdateModal(e, rowData)}
                          style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
                        >
                          <FontAwesomeIcon icon={faPenToSquare} />
                        </Comp.Button>
                    </span>
                  )}
                  {(actionAuthority.WRITE === "Y")&& (
                    <span title="Delete">
                      <Comp.Button
                        id="btnDelete"
                        type="delete"
                        onClick={() => showDeleteModal(rowData)}
                        style={{ width: "50px", height: "35px" }}
                      >
                        <FontAwesomeIcon icon={faTrashCan} />
                      </Comp.Button>
                    </span>
                  )}
                </div>
              )}
            />
            <Column
              body={(rowData, options) => options.rowIndex + 1}
              style={{ width: '3rem', height: "40px", textAlign: 'center' }}
            />
            <Column field="USERNAME" frozen style={{ minWidth: '160px' }} 
              body={(rowData) => (
                <HighlightCell text={rowData.USERNAME} keyword={rowData.__FILTER_KEYWORD__?.USERNAME || ''} />
              )}
            />
            <Column field="EMAIL" style={{ minWidth: '250px' }} 
              body={(rowData) => (
                <HighlightCell text={rowData.EMAIL} keyword={rowData.__FILTER_KEYWORD__?.EMAIL || ''} />
              )}
            />
            <Column field="DEPT_NAME" style={{ minWidth: '150px' }} 
              body={(rowData) => (
                <HighlightCell text={rowData.DEPT_NAME} keyword={rowData.__FILTER_KEYWORD__?.DEPT_NAME || ''} />
              )}
            />
            <Column field="ROLE_NAME" style={{ minWidth: '200px' }} 
              body={(rowData) => 
                <TruncatedHighlightCell text={rowData.ROLE_NAME} keyword={rowData.__FILTER_KEYWORD__?.ROLE_NAME || ''} />
              }
            />
            <Column field="EMPLOYMENT_STATUS" style={{ minWidth: '130px' }} 
              body={(rowData) => (
                <HighlightCell text={rowData.EMPLOYMENT_STATUS} keyword={rowData.__FILTER_KEYWORD__?.EMPLOYMENT_STATUS || ''} />
              )}
            />
            <Column field="SERVICE_LENGTH" style={{ minWidth: '200px' }} 
              body={(rowData) => (
                <HighlightCell text={rowData.SERVICE_LENGTH} keyword={rowData.__FILTER_KEYWORD__?.SERVICE_LENGTH || ''} />
              )}
              sortFunction={(e) => {

                const getTotalDays = (row) => {
                  const startDateStr = row.SERVICE_STARTDATE;
                  const endDateStr = row.SERVICE_ENDDATE;

                  if (!startDateStr) return 0;

                  const startDate = new Date(startDateStr);
                  let endDate = new Date();

                  if (endDateStr && new Date(endDateStr) > startDate) {
                    endDate = new Date(endDateStr);
                  }

                  // 🔥 most accurate
                  return Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));
                };

                return [...e.data].sort((a, b) =>
                  (getTotalDays(a) - getTotalDays(b)) * e.order
                );
              }}
            />
            <Column
              field="STATUS"
              style={{ textAlign: 'center' }}
              body={(rowData) => {
                const className =
                  rowData.STATUS === "Active"
                    ? CssClass.activeStatus
                    : CssClass.inactiveStatus;

                const handleToggle = (e, rowData) => {
                  showActivatorModal(e, rowData);
                };

                return (
                  <div className={CssClass.toggleWrapper}>
                    <label className={CssClass.switch}>
                      <input
                        type="checkbox"
                        checked={rowData.STATUS === "Active"}
                        onChange={(e) => handleToggle(e, rowData)}
                      />
                      <span className={CssClass.sliderRound}></span>
                    </label>
                  </div>
                );
              }}
            />
            <Column field="ANNUAL_LEAVE_ENTITLED" style={{ textAlign: 'center', backgroundColor: '#eafaec' }}></Column>
            <Column field="ANNUAL_LEAVE_BRINGFORWARD" style={{ textAlign: 'center', backgroundColor: '#eafaec' }}></Column>
            <Column field="ANNUAL_LEAVE_TAKEN" style={{ textAlign: 'center', color: '#006600', backgroundColor: '#eafaec', fontWeight: 'bold' }}></Column>
            <Column field="ANNUAL_LEAVE_BALANCE" style={{ textAlign: 'center', backgroundColor: '#eafaec' }}></Column>
            <Column field="ANNUAL_LEAVE_MTD_BALANCE" style={{ textAlign: 'center', backgroundColor: '#eafaec' }}></Column>
            <Column field="MEDICAL_LEAVE_ENTITLED" style={{ textAlign: 'center', backgroundColor: '#e1f2fb' }}></Column>
            <Column field="MEDICAL_LEAVE_TAKEN" style={{ textAlign: 'center', color: '#0000ff', backgroundColor: '#e1f2fb', fontWeight: 'bold' }}></Column>
            <Column field="MEDICAL_LEAVE_BALANCE" style={{ textAlign: 'center', backgroundColor: '#e1f2fb' }}></Column>
            <Column field="HOSPITALIZATION_LEAVE" style={{ textAlign: 'center', backgroundColor: '#e1f2fb' }}></Column>
            <Column field="UNPAID_LEAVE_TAKEN" style={{ textAlign: 'center', color: '#af002d', backgroundColor: '#ffefef', fontWeight: 'bold' }}></Column>
            <Column field="MEDICAL_LEAVE_CLAIM" style={{ textAlign: 'center', backgroundColor: '#ffeed5', minWidth: '130px' }}></Column>
            <Column field="LAST_ACCESS_DATETIME" style={{ minWidth: '160px' }}
              sortFunction={(e) => {
                const parseDate = (dateStr) => {
                  if (!dateStr) return new Date(0);

                  const [datePart, timePart] = dateStr.split(' ');
                  const [day, month, year] = datePart.split('/');

                  return new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day),
                    ...(timePart ? timePart.split(':').map(Number) : [0, 0, 0])
                  );
                };

                const sorted = [...e.data].sort((a, b) => {
                  const dateA = parseDate(a.LAST_ACCESS_DATETIME);
                  const dateB = parseDate(b.LAST_ACCESS_DATETIME);

                  return (dateA - dateB) * e.order;
                });

                return sorted;
              }}
            />
            <Column field="UPDATE_DATETIME" style={{ minWidth: '160px' }}
              sortFunction={(e) => {
                const parseDate = (dateStr) => {
                  if (!dateStr) return new Date(0);

                  const [datePart, timePart] = dateStr.split(' ');
                  const [day, month, year] = datePart.split('/');

                  return new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day),
                    ...(timePart ? timePart.split(':').map(Number) : [0, 0, 0])
                  );
                };

                const sorted = [...e.data].sort((a, b) => {
                  const dateA = parseDate(a.UPDATE_DATETIME);
                  const dateB = parseDate(b.UPDATE_DATETIME);

                  return (dateA - dateB) * e.order;
                });

                return sorted;
              }}
            />
            <Column field="UPDATED_BY" style={{ minWidth: '150px' }} 
              body={(rowData) => (
                <HighlightCell text={rowData.UPDATED_BY} keyword={rowData.__FILTER_KEYWORD__?.UPDATE_BY || ''} />
              )}
            />
          </DataTable>
        </div>
      </div>

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
      <CreateEmployee
        page={props.page}
        module={MODULE_ID}
        showHide={showCreateEmployee}
        onHide={createEmployeeModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
      
      <EmployeeUpdate
        page={props.page}
        module={MODULE_ID}
        showHide={showUpdate}
        editData={editData}
        onHide={hideUpdateModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
      
      {showDelete && (
        <EmployeeDelete
          page={props.page}
          module={MODULE_ID}
          showHide={showDelete}
          editData={editData}
          onHide={hideDeleteModal}
          onReload={onReloadHandler}
          onLoading={onLoadingHandler}
        />
      )}
      
      {showActivator && (
        <EmployeeActivator
          page={props.page}
          module={MODULE_ID}
          showHide={showActivator}
          editData={editData}
          onHide={hideActivatorModal}
          onReload={onReloadHandler}
          onLoading={onLoadingHandler}
        />
      )}
    </>
  );
};

export default Employee;
